/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { TaskEditView, ITaskEditOwnProps, ITaskEditDispatchProps, ITaskEditStateProps } from "../../components/task/taskEdit";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ITaskEditOwnProps): ITaskEditStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.task) || Base.isNullOrUndefined(applicationState.task.taskEdit)) {
        return {
            user: applicationState?.user,
            item: null,
            taskTypes: [],
            taskStates: [],
            taskPriorities: [],
            units: [],
            userCode: "",
            userName: "",
            userPicture: "",
            canHandleTask: false,
            canRemoveTask: false,
            canChangeTaskState: false,
            userIsIsSystemAdmin: false,
            returnUrl: ""
        };
    }
    const taskEdit = applicationState.task.taskEdit;
    return {
        user: applicationState?.user,
        item: taskEdit.item,
        taskTypes: taskEdit.taskTypes,
        taskStates: taskEdit.taskStates,
        taskPriorities: taskEdit.taskPriorities,
        units: taskEdit.units,
        userCode: taskEdit.userCode,
        userName: taskEdit.userName,
        userPicture: taskEdit.userPicture,
        canHandleTask: taskEdit.canHandleTask,
        canRemoveTask: taskEdit.canRemoveTask,
        canChangeTaskState: taskEdit.canChangeTaskState,
        userIsIsSystemAdmin: taskEdit.userIsIsSystemAdmin,
        returnUrl: taskEdit.returnUrl
    };
}

export function mapDispatchToProps(dispatch: storeEffects.TaskThunkDispatch): ITaskEditDispatchProps {
    return {
        loadTask: (id: string) => dispatch(storeEffects.getTaskEdit(id)),
        resetTask: () => dispatch(storeActions.taskEditReset())
    };
}

export default withRouter(connect<ITaskEditStateProps, ITaskEditDispatchProps, ITaskEditOwnProps>(mapStateToProps, mapDispatchToProps)(TaskEditView));